var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    id: "Chat",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      marker: "none"
    },
    fill: "#b37825",
    d: "M-940-128c-.554 0-1 .446-1 1v8c0 .554.446 1 1 1h2v1.83a.5.5 0 0 0 .5.49.5.5 0 0 0 .379-.173l.004-.004 2.094-2.143H-928c.554 0 1-.446 1-1v-8c0-.554-.446-1-1-1h-12z",
    color: "#000",
    overflow: "visible",
    transform: "translate(942 130)",
    className: "color25b39e svgShape"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbf66",
    fillRule: "evenodd",
    d: "M4 4h9v1H4zM4 6h9v1H4zM8 8h5v1H8z",
    className: "color60c5b8 svgShape"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chatIcon.8bb5514886917b1faa64b841b1f8016d.svg";
export { ForwardRef as ReactComponent };